module.exports = __webpack_public_path__ + "img/face.26155cd5.png";